<template>
    <div>
        <!-- Tags Section -->
        <div class="campaign-option" v-if="regularTags.length > 0">
            <div class="campaign-option--title">
                Tags
                <info-tooltip text="Select the tags you wish to apply to this ad set."></info-tooltip>
            </div>

            <div class="campaign-adset-location__input">
                <multiselect
                        v-model="selectedRegularTags"
                        :multiple="true"
                        :options="regularTags"
                        label="label"
                        :close-on-select="false"
                        :hide-selected="true"
                        track-by="id"
                        :placeholder="regularTagsPlaceholder"
                        :show-labels="false">
                </multiselect>
            </div>
        </div>

        <!-- Display Targets Section -->
        <div class="campaign-option" v-if="displayTargets.length > 0">
            <div class="campaign-option--title">
                Display Targets
                <info-tooltip text="Select the display targets you wish to apply to this ad set."></info-tooltip>
            </div>

            <div class="campaign-adset-location__input">
                <multiselect
                        v-model="selectedDisplayTargets"
                        :multiple="true"
                        :options="displayTargets"
                        label="label"
                        :close-on-select="false"
                        :hide-selected="true"
                        track-by="id"
                        :placeholder="displayTargetsPlaceholder"
                        :show-labels="false">
                </multiselect>
            </div>
        </div>
    </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'

  export default {
    components: { Multiselect },

    props: {
      value: Array,
      options: Array
    },

    data() {
      return {
        selectedRegularTags: [],
        selectedDisplayTargets: []
      }
    },

    created() {
      // Initialize selections
      this.splitAndSetTags(this.value);
    },

    watch: {
      value: {
        handler(newValue) {
          this.splitAndSetTags(newValue);
        },
        deep: true
      },

      selectedRegularTags: {
        handler() {
          this.emitChanges();
        },
        deep: true
      },

      selectedDisplayTargets: {
        handler() {
          this.emitChanges();
        },
        deep: true
      }
    },

    computed: {
      regularTags() {
        return this.options.filter(tag => !this.isDisplayTarget(tag.label));
      },

      displayTargets() {
        return this.options.filter(tag => this.isDisplayTarget(tag.label));
      },

      regularTagsPlaceholder() {
        return this.selectedRegularTags.length > 0 ? '' : 'Optional - Choose Tags';
      },

      displayTargetsPlaceholder() {
        return this.selectedDisplayTargets.length > 0 ? '' : 'Optional - Choose Display Targets';
      }
    },

    methods: {
      isDisplayTarget(label) {
        if (!label) return false;
        // Cache the regex for better performance
        if (!this._displayTargetRegex) {
          this._displayTargetRegex = /.*:\d+$/;
        }
        return this._displayTargetRegex.test(label);
      },

      splitAndSetTags(tags) {
        if (!Array.isArray(tags)) {
          this.selectedRegularTags = [];
          this.selectedDisplayTargets = [];
          return;
        }

        // Use computed properties to avoid duplicate filtering
        this.selectedRegularTags = this.filterRegularTags(tags);
        this.selectedDisplayTargets = this.filterDisplayTargets(tags);
      },

      filterRegularTags(tags) {
        return tags.filter(tag => !this.isDisplayTarget(tag.label));
      },

      filterDisplayTargets(tags) {
        return tags.filter(tag => this.isDisplayTarget(tag.label));
      },

      emitChanges() {
        // Debounce the emit to prevent too many rapid updates
        if (this._emitTimeout) {
          clearTimeout(this._emitTimeout);
        }

        this._emitTimeout = setTimeout(() => {
          const combinedTags = [...this.selectedRegularTags, ...this.selectedDisplayTargets];
          this.$emit('input', combinedTags);
        }, 100);
      }
    },

    beforeDestroy() {
      // Clean up timeout if component is destroyed
      if (this._emitTimeout) {
        clearTimeout(this._emitTimeout);
      }
    }
  }
</script>
